// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---_2CHt","changedRecordsList":"changedRecordsList---gxs29","changedRecord":"changedRecord---Kr0bV"};